import React from 'react';
import ReactDOM from 'react-dom';
import injectUser from 'lib/inject-user';
import App from './app';
import WithApollo from './components/with-apollo';

const Root = () => <WithApollo>{injectUser(App)}</WithApollo>;

ReactDOM.render(<Root />, document.getElementById('root'));
